import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";import Modal from"@wp/src/components/common/modal";import{InfoIconButton}from"@wp/src/components/common/buttons/InfoIconButton";export const EasyImportSecuritiesPopup=styled(Modal)`
  .ant-modal-content {
    padding: 16px;
  }

  .ant-modal-body {
    padding: 8px 0;
  }
`;export const EasyImportSecuritiesContentContainer=styled(FlexLayout)`
  width: 100%;
`;export const PortfolioImportActionButton=styled(InfoIconButton)``;